import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://wseyxqqorvqditiuxxzc.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndzZXl4cXFvcnZxZGl0aXV4eHpjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU3NjEwMDQsImV4cCI6MjA4MTMzNzAwNH0.7ZxFtGcpqe48Utk7ymS2Yr9iCK-pmQwuccNZSEwVTj4'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})